<div class="my-5">
  <sm-page-header
    [breadcrumb]="breadcrumb"
    title="settings.contractingAuthority.ac.title">
  </sm-page-header>
  <div class="content">
     <div class="flex justify-end mb-4">
            <p-button [label]="'settings.contractingAuthority.history.check' | translate" (click)="router.navigate(['/settings/contracting-authority/ac-history'])" severity="info"/>
        </div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
  <sm-dialog #dialog [dialog]="contractingAuthorityDialog"></sm-dialog>
</div>
